import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import classnames from "classnames";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Input, Spinner, Form, Nav, NavItem, NavLink, TabContent, TabPane, Progress } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";

import { useDispatch, useSelector } from "react-redux";
import * as idiProjectActions from "../actions/IdiProjectActions";
import * as commonActions from "../actions/CommonActions";

const IdiProjectAddScreen  = () => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.idi.loadingFBO);
    const fbo = useSelector((state) => state.idi.fbo);
    
    const [fboState, setFBOState] = React.useState(fbo);
        
    const [progressbarvalue, setprogressbarvalue] = React.useState(0);
    const [activeTab, setactiveTab] = React.useState(1);
    const [passedSteps, setPassedSteps] = React.useState([1]);

    React.useEffect(() => {
	    dispatch(idiProjectActions.loadIdiProject(null, navigate));
    }, []);

    React.useEffect(() => {
		setFBOState(fbo);

        if(fbo != null) {
            reset(fbo.idiProject);
        }
        clearErrors();
    }, [fbo]);

    async function toggleTab(tab, value) {
        if(value === 100) {
            const valid = await trigger(['lotRefNo', 'sourceName', 'tawuniyaRefNo', 'baladyRefNo']);
            if(valid) {
                if (activeTab !== tab) {
                    var modifiedSteps = [...passedSteps, tab];
        
                    if (tab >= 1 && tab <= 4) {
                        setactiveTab(tab);
                        setPassedSteps(modifiedSteps);
                    }
                }
        
                setprogressbarvalue(value);
            }
        }
        else {
            if (activeTab !== tab) {
                var modifiedSteps = [...passedSteps, tab];
    
                if (tab >= 1 && tab <= 4) {
                    setactiveTab(tab);
                    setPassedSteps(modifiedSteps);
                }
            }
    
            setprogressbarvalue(value);
        }
        
    }

    const onIdiProjectChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.idiProject[name] = value;
        }
        else if(value === false) {
            copy_fboState.idiProject[name] = false;
        }
        else {
            copy_fboState.idiProject[name] = null;
        }
                
        setFBOState(copy_fboState);
    }

    const onSaveIdiProject = async() => {
        const valid = await trigger();
        
        if(valid) {
            dispatch(idiProjectActions.saveIdiProject(fboState, "", "", navigate));
        }
    }

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={"Add IDI Project"} />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="text-center pt-3 pb-4 mb-1">
                                        <h5>Create New IDI Project</h5>
                                    </div>
                                    
                                    <div className="progress-nav mb-4">
                                        <Progress
                                            value={progressbarvalue}
                                            style={{ height: "1px" }}
                                        />

                                        <Nav className="nav-pills progress-bar-tab custom-nav" role="tablist">
                                            <li className="nav-item">
                                                <button type="button" 
                                                    className={classnames(
                                                    {
                                                        active: activeTab === 1,
                                                        done: activeTab <= 2 && activeTab >= 0,
                                                    },
                                                    "rounded-pill nav-link"
                                                    )}
                                                >1</button>
                                            </li>
                                            <li className="nav-item">
                                                <button type="button" 
                                                    className={classnames(
                                                    {
                                                        active: activeTab === 2,
                                                        done: activeTab <= 2 && activeTab > 1,
                                                    },
                                                    "rounded-pill nav-link"
                                                    )}
                                                >2</button>
                                            </li>
                                        </Nav>
                                    </div>

                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId={1}>
                                            <div>
                                                <div className="mb-4">
                                                    <div>
                                                        <h5 className="mb-1">Fill IDI Project Basic Info</h5>
                                                    </div>
                                                </div>
                                                <Row className="gy-2">
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Project #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.projectNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Status</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.status) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Lot Ref #<span className="required">*</span></Label>
                                                        <input type="text" className={`form-control ${errors.lotRefNo ? "is-invalid" : ""}`}
                                                            title={errors.lotRefNo?.message}
                                                            value={(fboState && fboState.idiProject.lotRefNo) || ""}
                                                            {...register("lotRefNo", { required: "Lot Ref # is required" })}
                                                            onChange={e => onIdiProjectChange("lotRefNo", e.target.value, false)}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Request For Proposal</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.idiProject.requestForProposal) || ""}
                                                            onChange={e => onIdiProjectChange("requestForProposal", e.target.value, false)}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Source Name<span className="required">*</span></Label>
                                                        <select className={`form-select ${errors.sourceName ? "is-invalid" : ""}`}
                                                            title={errors.sourceName?.message}
                                                            value={(fboState && fboState.idiProject.sourceName) || ""}
                                                            {...register("sourceName", { required: "Source Name is required" })}
                                                            onChange={e => onIdiProjectChange("sourceName", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Tawuniya">Tawuniya</option>
                                                            <option value="Balady">Balady</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Tawuniya Ref #{fboState && fboState.idiProject.sourceName === "Tawuniya" && <span className="required">*</span>}</Label>
                                                        <input type="text" className={`form-control ${errors.tawuniyaRefNo ? "is-invalid" : ""}`}
                                                            title={errors.tawuniyaRefNo?.message}
                                                            value={(fboState && fboState.idiProject.tawuniyaRefNo) || ""}
                                                            {...register("tawuniyaRefNo", { 
                                                                validate: (value) => {
                                                                    if (fboState && fboState.idiProject.sourceName === "Tawuniya" && !value) {
                                                                        return "Tawuniya Ref # is required";
                                                                    }

                                                                    return true;
                                                                }
                                                            })}
                                                            onChange={e => onIdiProjectChange("tawuniyaRefNo", e.target.value, false)}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Balady Ref #{fboState && fboState.idiProject.sourceName === "Balady" && <span className="required">*</span>}</Label>
                                                        <input type="text" className={`form-control ${errors.baladyRefNo ? "is-invalid" : ""}`}
                                                            title={errors.baladyRefNo?.message}
                                                            value={(fboState && fboState.idiProject.baladyRefNo) || ""}
                                                            {...register("baladyRefNo", { 
                                                                validate: (value) => {
                                                                    if (fboState && fboState.idiProject.sourceName === "Balady" && !value) {
                                                                        return "Balady Ref # is required";
                                                                    }

                                                                    return true;
                                                                }
                                                            })}
                                                            onChange={e => onIdiProjectChange("baladyRefNo", e.target.value, false)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                                    onClick={() => {
                                                    toggleTab(activeTab + 1, 100);
                                                    }}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                                    Next
                                                </button>
                                            </div>
                                        </TabPane>

                                        <TabPane tabId={2}>
                                            <div>
                                                <div className="mb-4">
                                                    <div>
                                                        <h5 className="mb-1">Fill CRM Info</h5>
                                                    </div>
                                                </div>
                                                <Row className="gy-2">
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">CRM Name<span className="required">*</span></Label>
                                                        <select className={`form-select ${errors.crmName ? "is-invalid" : ""}`}
                                                            title={errors.crmName?.message}
                                                            value={(fboState && fboState.idiProject.crmName) || ""}
                                                            {...register("crmName", { required: "CRM Name is required" })}
                                                            onChange={e => onIdiProjectChange("crmName", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="saudi">Saudi Arabia</option>
                                                            {/* {fboState && fboState.crmList.map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.crmName}>{item.crmLabel}</option>
                                                                );
                                                            })} */}
                                                        </select>
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Invoice Country<span className="required">*</span></Label>
                                                        <select className={`form-select ${errors.crmCountry ? "is-invalid" : ""}`}
                                                            title={errors.crmCountry?.message}
                                                            value={(fboState && fboState.idiProject.crmCountry) || ""}
                                                            {...register("crmCountry", { required: "Invoice Country is required" })}
                                                            onChange={e => onIdiProjectChange("crmCountry", e.target.value, false)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="Saudi Arabia">Saudi Arabia</option>
                                                            {/* {fboState && fboState.crmCountryList.filter(x => x.crmName == fboState.idiProject.crmName).map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                                                );
                                                            })} */}
                                                        </select>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-link text-decoration-none btn-label previestab"
                                                    onClick={() => {
                                                        toggleTab(activeTab - 1, 0);
                                                    }}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                                    Back
                                                </button>
                                                <button
                                                    disabled={loading}
                                                    type="button"
                                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                                    onClick={() => onSaveIdiProject()}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                                    Submit
                                                </button>
                                            </div>
                                        </TabPane>
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IdiProjectAddScreen;